module.exports = __webpack_public_path__ + "static/media/nfg_logo_black.257aa796.svg";